import { URLS } from 'src/constants/urls';
import { isLikelyBot } from 'src/helpers/analytics/botUtils';

export const setIdentityEvent = (
  userId: number,
  userEmail: string,
  userName: string,
  accountType: string | null,
) => {
  //this is the first event that sets identity for google tag manger and mix panel

  // Bot Detection: Skip if traffic appears to be from a bot/crawler
  // Note: Using standard detection (not strict) to avoid false positives
  // isLikelyBotStrict() was blocking legitimate users due to chrome.runtime check
  if (isLikelyBot()) {
    console.log('[Analytics] Skipping identity event - bot traffic detected');
    return;
  }

  // Skip sending the event if accountType is 'producer'
  if (accountType === 'producer') {
    console.log('Skipping GTM identity event for producer accountType');
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'setUserIdentity',
    userId: userId.toString(),
    userEmail: userEmail,
    userName: userName,
  });

  // 2. Fire delayed GTM custom event 'triggerPeopleSet'
  setTimeout(() => {
    // Re-check bot status before firing delayed event
    if (isLikelyBot()) {
      console.log('[Analytics] Skipping delayed identity event - bot traffic detected');
      return;
    }
    window.dataLayer!.push({
      event: 'triggerPeopleSet',
      userId: userId.toString(),
      userEmail: userEmail,
      userName: userName,
    });
  }, 5000); // 500ms delay is usually enough, adjust as needed
};

export const trackGTMEvent = (
  eventName: string,
  eventDetails: Record<string, unknown>,
  accountType?: string | null,
) => {
  try {
    // Bot Detection: Skip if traffic appears to be from a bot/crawler
    // Using standard detection for regular events to prevent bot pollution
    if (isLikelyBot()) {
      console.log(`[Analytics] Skipping event "${eventName}" - bot traffic detected`);
      return;
    }

    // Skip sending the event if accountType is 'producer'
    if (accountType === 'producer') {
      console.log('Skipping GTM event for producer accountType');
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...eventDetails,
    });
  } catch (error) {
    console.error('Error tracking GTM event:', error);
  }
};

export const trackTabsPressed = (route: string, accountType: string) => {
  switch (route) {
    case URLS.VEHICLE.START:
      return trackGTMEvent('vehicle-tab-pressed', {}, accountType);
    case URLS.DRIVER.LICENSE:
      return trackGTMEvent('driver-tab-pressed', {}, accountType);
    case URLS.FREIGHT:
      return trackGTMEvent('freight-tab-pressed', {}, accountType);
    case URLS.APPLICATION.INSURANCE:
      return trackGTMEvent('final-details-tab-pressed', {}, accountType);
    case URLS.QUOTE.SUCCESS:
      return trackGTMEvent('quote-tab-pressed', {}, accountType);
  }
};
